import { render, staticRenderFns } from "./Radio.vue?vue&type=template&id=075a3fbb&"
import script from "./Radio.vue?vue&type=script&lang=ts&"
export * from "./Radio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('075a3fbb')) {
      api.createRecord('075a3fbb', component.options)
    } else {
      api.reload('075a3fbb', component.options)
    }
    module.hot.accept("./Radio.vue?vue&type=template&id=075a3fbb&", function () {
      api.rerender('075a3fbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/inputs/Radio.vue"
export default component.exports